import { render, staticRenderFns } from "./SidebarClass.vue?vue&type=template&id=11a85fc6&scoped=true&"
import script from "./SidebarClass.vue?vue&type=script&lang=js&"
export * from "./SidebarClass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a85fc6",
  null
  
)

export default component.exports